import { AuthError } from "@/lib/auth/errors/auth-error";
import { logger } from "@/lib/logger";

export const wrapper = async <T>(cb: () => Promise<T>): Promise<T> => {
  try {
    return await cb();
  } catch (err) {
    logger.error({ err }, `${cb.name} error`);
    throw new AuthError(err);
  }
};
